import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error" }
const _hoisted_2 = ["href"]

import { useStore } from "vuex";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateIncomeSourcesError',
  setup(__props) {

const store = useStore();

const hrefTFN = computed<string>(() => {
  return store.state.lenderData && store.state.lenderData.tollFreeNumber
    ? `+${store.state.lenderData.tollFreeNumber.replace(/-/g, "")}`
    : "N/A";
});
const tollFreeNumber = computed<string>(() => {
  return store.state.lenderData && store.state.lenderData.tollFreeNumber
    ? store.state.lenderData.tollFreeNumber
    : "N/A";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createTextVNode(" An error occurred while trying to update your selection(s). Please try again. If the issue continues, please contact our support team at ", -1)),
    _createElementVNode("a", {
      class: "inline-link",
      href: `tel:${hrefTFN.value}`
    }, _toDisplayString(tollFreeNumber.value), 9, _hoisted_2),
    _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
  ]))
}
}

})